module.exports = __webpack_public_path__ + "img/mullins-sneak-fight.8dc47e5a.jpg";